var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", { staticClass: "loading_holder" }, [
        _c("div", { staticClass: "spinner_holder" }, [_c("c-spinner")], 1)
      ])
    : _c(
        "v-container",
        [
          _c(
            "v-jumbotron",
            {
              attrs: {
                gradient: _vm.gradient,
                light: "",
                src: "/static/images/13.jpg",
                height: "82vh"
              }
            },
            [
              _c(
                "v-container",
                { attrs: { "fill-height": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "" } },
                    [
                      _c(
                        "v-flex",
                        [
                          _c("h3", { staticClass: "display-3 title1" }, [
                            _vm._v("Great!")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "headline title2" }, [
                            _vm._v(
                              "You have purchased our  " +
                                _vm._s(this.plan) +
                                " (" +
                                _vm._s(this.credit) +
                                " credits). Your confrimation number is " +
                                _vm._s(this.confirmation) +
                                ". Your account will be updated monetarily."
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "title mb-3 middleText1" }, [
                            _vm._v("Let's submit your art piece!")
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mx-0",
                              attrs: {
                                color: "primary",
                                depressed: "",
                                to: "/artist_dashboard"
                              }
                            },
                            [_vm._v("\n            Submit Art\n          ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01d3c581", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01d3c581","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artists/payment_confirmation.vue
// module id = null
// module chunks = 